export const state = {
	showTeamsAlert: true,
	showChartsAlert: true,
	showInfoModal: true,
};
